import { render, staticRenderFns } from "./ForgetPasswd.vue?vue&type=template&id=70b73342&scoped=true&"
import script from "./ForgetPasswd.vue?vue&type=script&lang=js&"
export * from "./ForgetPasswd.vue?vue&type=script&lang=js&"
import style0 from "./ForgetPasswd.vue?vue&type=style&index=0&id=70b73342&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b73342",
  null
  
)

export default component.exports